export default {"src":"/_next/static/media/human.f58bcbff.svg","height":123,"width":122};